import { trackUser } from '@api/tracking/client';
import type { TourItemKey } from '../hooks/use-tour-store';

export function trackTourStepCompletion(tourStep: TourItemKey): void {
  trackUser({
    event: 'Completed editor tour step',
    properties: {
      'tour step': tourStep,
    },
  });
}

export function trackTourStepSeen(tourStep: TourItemKey): void {
  trackUser({
    event: 'Seen editor tour step',
    properties: {
      'tour step': tourStep,
    },
  });
}

export function trackEditorTourSeen(): void {
  trackUser({
    event: 'Viewed editor tour welcome',
  });
}

/**
 * Tracks when the user completes the entire editor tour
 */
export function trackEditorTourCompleted(): void {
  trackUser({
    event: 'Completed editor tour',
  });
}
